export const MAC_SYSTEM_NAME = {
  HPC_SHEV: "HPC_SHEV",
  HPC_SHEV_P6: "HPC_SHEV_P6",
  TLM_27BEV: "TLM_27BEV",
  ADAS: "ADAS",
  EV: "EV"
};